import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const SearchGrey = () => (
  <ImageIcon src={Images.SearchGrey} alt="search-grey" />
);

export default SearchGrey;
